<script>
    import {scaleLinear, max, mean, selectAll } from "d3";
    import { fade, blur, fly, slide, scale } from "svelte/transition";
    import { quintOut } from "svelte/easing";
    import { flip } from "svelte/animate";
    import { selectedCity, selectedCityName, selectedCountry } from "../shared/stores.js";
    // import AxisBS from "./AxisBS.svelte";
	// import {uniqueKey, onlyUnique} from "../utils.js";
    // import {tooltip} from "../tooltip.js";
    // import {selectedCountry} from "../shared/stores.js"
    // export let stories;
    // export let topic;
    // export let topicType;
    // export let xVar;
	// export let view;
	// export let bHeight;
    // export let showLegend;
    export let data;
    export let innerWidth;
    export let mainDrawColor;
    export let mainSpecialColor;
    export let mainBgColorControls;
    export let mainBorderColor;
    export let country;
    export let highlightCities;
    export let fifteenMinProp;
    export let width;
    export let axisLabel;
    export let map;
    export let mapboxgl;
    export let accessScale;
    export let darkMode;
    export let walkingTime;
    export let borderWidthTooltip;
    export let boxShadow;
    export let mainSvgColor;
    export let flyToNewCity;
    // export let radius;
    // export let getRscale;
    export let rScale;

    let distanceToNormGlobe = scaleLinear()
						   .domain([0, max(data, d=>d.mobility)])
						   .range([1,0])

    // $: console.log("selectedCity", selectedCity)
    // $: console.log("selectedCityData", data.filter(d=>highlightCities.includes(d.UC_NM_CTR)))
    // $: console.log("width", width)
    // $: data = data.map(d=>({...d, fifteenPropAccess: d.UC_NM_CTR===selectedCity?fifteenMinProp:d.fifteenPropAccess}))

    // get the ID of the selected city
    $: selectedCityId = data.filter(d=>highlightCities.includes(d.UC_NM_CTR))[0].ID_HDC_G0

    // let radius = 1.5;
    let bHeight = 80;
    // $: width = 300;
    let xVar = "fifteenPropAccess"
    $: cityHovered = null;
    $: cityhoveredY = null;
    // merge and process datasets
    // $: countries = aggData.filter(d=>d.Country).filter(onlyUnique).map(d=> //.filter(d=>d!==null).concat("All countries").reverse()
    //     { 
    //         return {
    //             value: d,
    //             // label: d
    //             label: d==="Viet Nam"?"Vietnam":d
    //         }
    //     })

	// let filteredStories;
	// $: filteredStories = stories.filter(d=>$selectedCountry===""?(countries.map(d=>d.value).includes(d.Country)):(d.Country!==null)&&(d.Country===$selectedCountry))
    // $: data = aggData.filter(d=>d.CTR_MN_NM===country).map(d=>({...d, fifteenPropAccess:+((+d.fifteenPopAccess/+d.P15)*100)}))
    // $: console.log("country data", data)

    $: countryAvg = country!=="World"?mean(data, d => d[xVar]):42

    // $: HRT = stories.map(d => d["HumanRightsTopic"]).filter(onlyUnique).filter(d=>d!==null&&d!=="Other"&&d!=="").concat("Other")


	// $: legendHeight = 15
	// $: legendTickWidth = 30
	// $: legendTickRadius = 10
	// let cornerSmoothing = 10

    let margin = {left: 15, right: 15, top: 10, bottom: 15}//right:25
	let height = 600//400//
    // $: bHeight = 1500
	$: seed = 1
	$: randomness1 = 0
	$: randomness2 = 0

	// $: cScale = d3.scaleOrdinal()
	// 	.domain(HRT)
	// 	.range(d3.schemeTableau10);

	// $: rScale = d3
	// 	.scaleSqrt()
	// 	.domain([0,100])
	// 	.range([radius*2, radius*2])
    // $: rScale = getRscale(data, radius, innerWidth)

    

	$: extentX = [0, 100]//d3.extent(data, d=>d.fifteenPropAccess)
    
	$: xScale = 
		scaleLinear()
		// .domain([d3.max(stories, d=>d.Date), d3.min(stories, d=>d.Date)])
		.domain(extentX)
		// .range([0+margin.top, bHeight-margin.bottom])
		.range([0+margin.left, width-margin.right])
		.clamp(true)
		.nice()

	// $: xTicks = d3.range(extentX[0], extentX[1], 4)
	$: xTicks = [0, 25, 50, 75, 100]


    class AccurateBeeswarm {
        constructor(items, radius, xFun) {
            this.items = items;
            this.diameter = radius * 2;
            this.diameterSq = this.diameter * this.diameter;
            this.xFun = xFun;
            this.tieBreakFn = x => x;
            this._oneSided = false;
        }

        withTiesBrokenRandomly() {
            this.tieBreakFn = this._sfc32(0x9E3779B9, 0x243F6A88, 0xB7E15162, 1);
            return this;
        }

        oneSided() {
            this._oneSided = true;
            return this;
        }

        calculateYPositions() {
            let all = this.items.map((d,i) => ({
                datum: d,
                originalIndex: i,
                x: this.xFun(d),
                y: null,
                placed: false,
                minPositiveY: 0,
                maxNegativeY: 0,
                score: 0,
                bestPosition: 0,
                heapPos: -1
            })).sort((a,b) => a.x - b.x);
            all.forEach(function (d, i) {d.index = i;});
            let tieBreakFn = this.tieBreakFn;
            all.forEach(function(d) {d.tieBreaker = tieBreakFn(d.x)});
            let pq = new AccurateBeeswarmPriorityQueue();
            pq.push(...all);
            while (!pq.isEmpty()) {
                let item = pq.pop();
                item.placed = true;
                item.y = item.bestPosition;
                this._updateYBounds(item, all, pq);
            }
            all.sort((a, b) => a.originalIndex - b.originalIndex);
            return all.map(d => ({datum: d.datum, x: d.x, y: d.y}));
        }

        // Random number generator
        // https://stackoverflow.com/a/47593316
        _sfc32(a, b, c, d) {
            let rng = function() {
                a >>>= 0; b >>>= 0; c >>>= 0; d >>>= 0;
                var t = (a + b) | 0;
                a = b ^ b >>> 9;
                b = c + (c << 3) | 0;
                c = (c << 21 | c >>> 11);
                d = d + 1 | 0;
                t = t + d | 0;
                c = c + t | 0;
                return (t >>> 0) / 4294967296;
            }
            for (let i=0; i<10; i++) {
                rng();
            }
            return rng;
        }

        _updateYBounds(item, all, pq) {
            for (let step of [-1, 1]) {
                let xDist;
                for (let i = item.index + step;
                        i >= 0 && i < all.length && (xDist = Math.abs(item.x - all[i].x)) < this.diameter;
                        i += step) {
                    let other = all[i];
                    if (other.placed) continue;
                    let yDist = Math.sqrt(this.diameterSq - xDist * xDist);
                    other.minPositiveY = Math.max(other.minPositiveY, item.y + yDist);
                    let prevScore = other.score;
                    other.score = other.minPositiveY;
                    other.bestPosition = other.minPositiveY;
                    if (!this._oneSided) {
                        other.maxNegativeY = Math.min(other.maxNegativeY, item.y - yDist);
                        if (-other.maxNegativeY < other.score) {
                            other.score = -other.maxNegativeY;
                            other.bestPosition = other.maxNegativeY;
                        }
                    }
                    if (other.score > prevScore) {
                        // It is never the case that other.score < prevScore here.
                        // The if statement is unnecessary, but makes the algorithm
                        // run a little faster.
                        pq.deprioritise(other);
                    }
                }
            }
        }
    }
    class AccurateBeeswarmPriorityQueue {
        // Based on https://stackoverflow.com/a/42919752
        parent(i) {return ((i + 1) >>> 1) - 1;}
        left(i) {return (i << 1) + 1;}
        right(i) {return (i + 1) << 1;}

        constructor() {
            this.TOP = 0;
            this._heap = [];
        }
        size() {
            return this._heap.length;
        }
        isEmpty() {
            return this.size() == 0;
        }
        peek() {
            return this._heap[this.TOP];
        }
        push(...values) {
            values.forEach(value => {
                value.heapPos = this.size();
                this._heap.push(value);
                this._siftUp();
            });
            return this.size();
        }
        pop() {
            const poppedValue = this.peek();
            const bottom = this.size() - 1;
            if (bottom > this.TOP) {
                this._swap(this.TOP, bottom);
            }
            this._heap.pop();
            this._siftDown();
            return poppedValue;
        }
        // Caution: this only works if new priority is less than or equal to old one.
        deprioritise(item) {
            this._siftDown(item.heapPos);
        }
        _greater(i, j) {
            let a = this._heap[i];
            let b = this._heap[j];
            if (a.score < b.score) return true;
            if (a.score > b.score) return false;
            return a.tieBreaker < b.tieBreaker;
        }
        _swap(i, j) {
            let tmp = this._heap[i];
            this._heap[i] = this._heap[j];
            this._heap[j] = tmp;
            this._heap[i].heapPos = i;
            this._heap[j].heapPos = j;
        }
        _siftUp() {
            let node = this.size() - 1;
            while (node > this.TOP && this._greater(node, this.parent(node))) {
                this._swap(node, this.parent(node));
                node = this.parent(node);
            }
        }
        _siftDown(node = this.TOP) {
            let l, r
            let sz = this.size();
            while (l = this.left(node), r = this.right(node),
                (l < sz && this._greater(l, node)) ||
                (r < sz && this._greater(r, node))
            ) {
                let maxChild = (r < sz && this._greater(r, l)) ? r : l;
                this._swap(node, maxChild);
                node = maxChild;
            }
        }
    }

    class AccurateBeeswarmOld {
		constructor(items, radiusFun, xFun) {
			this.items = items;
			this.radiusFun = radiusFun;
			this.xFun = xFun;
			this.tieBreakFn = this._sfc32(0x9E3779B9, 0x243F6A88, 0xB7E15162, seed);
			this.maxR = Math.max(...items.map(d => radiusFun(d)));
			this.rng = this._sfc32(1, 2, 3, seed);
		}

		calculateYPositions() {
			let all = this.items
			.map((d, i) => ({
				datum: d,
				originalIndex: i,
				x: this.xFun(d),
				y: null,
				placed: false
			}))
			.sort((a, b) => a.x - b.x);
			all.forEach(function(d, i) {
			d.index = i;
			});
			let tieBreakFn = this.tieBreakFn;
			all.forEach(function(d) {
			d.tieBreaker = tieBreakFn(d.x);
			});
			let allSortedByPriority = [...all].sort((a, b) => {
			let key_a = this.radiusFun(a.datum) + a.tieBreaker * randomness1;
			let key_b = this.radiusFun(b.datum) + b.tieBreaker * randomness1;
			return key_b - key_a;
			});
			for (let item of allSortedByPriority) {
			item.placed = true;
			item.y = this._getBestYPosition(item, all);
			}
			all.sort((a, b) => a.originalIndex - b.originalIndex);
			return all.map(d => ({ datum: d.datum, x: d.x, y: d.y }));
		}

		// Random number generator (for reproducibility)
		// https://stackoverflow.com/a/47593316
		_sfc32(a, b, c, d) {
			let rng = function() {
			a >>>= 0;
			b >>>= 0;
			c >>>= 0;
			d >>>= 0;
			var t = (a + b) | 0;
			a = b ^ (b >>> 9);
			b = (c + (c << 3)) | 0;
			c = (c << 21) | (c >>> 11);
			d = (d + 1) | 0;
			t = (t + d) | 0;
			c = (c + t) | 0;
			return (t >>> 0) / 4294967296;
			};
			for (let i = 0; i < 10; i++) {
			rng();
			}
			return rng;
		}

		_getBestYPosition(item, all) {
			let forbiddenIntervals = [];
			for (let step of [-1, 1]) {
			let xDist;
			let r = this.radiusFun(item.datum);
			for (
				let i = item.index + step;
				i >= 0 &&
				i < all.length &&
				(xDist = Math.abs(item.x - all[i].x)) < r + this.maxR;
				i += step
			) {
				let other = all[i];
				if (!other.placed) continue;
				let sumOfRadii = r + this.radiusFun(other.datum);
				if (xDist >= r + this.radiusFun(other.datum)) continue;
				let yDist = Math.sqrt(sumOfRadii * sumOfRadii - xDist * xDist);
				let forbiddenInterval = [other.y - yDist, other.y + yDist];
				forbiddenIntervals.push(forbiddenInterval);
			}
			}
			if (forbiddenIntervals.length == 0) {
			return this.radiusFun(item.datum) * (this.rng() - .5) * randomness2;
			}
			let candidatePositions = forbiddenIntervals.flat();
			candidatePositions.push(0);
			candidatePositions.sort((a, b) => {
			let abs_a = Math.abs(a);
			let abs_b = Math.abs(b);
			if (abs_a < abs_b) return -1;
			if (abs_a > abs_b) return 1;
			return a - b;
			});
			// find first candidate position that is not in any of the
			// forbidden intervals
			for (let i = 0; i < candidatePositions.length; i++) {
			let position = candidatePositions[i];
			if (
				forbiddenIntervals.every(
				interval => position <= interval[0] || position >= interval[1]
				)
			) {
				return position;
			}
			}
		}
	}


	$: positionedData = country!=="x"?
        new AccurateBeeswarmOld(
            data,//.filter(d=>selectedCountries.includes("All Countries")?d.country!=="":selectedCountries.includes(d.country)),
            d => rScale(+d.P15) + 0.6,
            d => xScale(+d[xVar])
            ).calculateYPositions():[]

    // $: positionedData = country!=="x"?
    //     new AccurateBeeswarm(
    //         data, 
    //         d => rScale(+d.P15) + 0.6,
    //         d => xScale(+d[xVar])
    //     )
    //     .oneSided()
    //     .calculateYPositions()
    //     :[];//.map(({ datum, x, y }) => ({ data: datum, x, y }))


	// $: console.log("bs", positionedData)

	// function bsMouseOver(data) {
	// 	d3.select("#"+data.datum.StoryNumber)
	// 		.attr("r", rScale(data.datum.Uniqueness)+4)
	// 		.attr("stroke-width", "2")
	// 		.raise()
	// }

	// function bsMouseOut(data) {
	// 	d3.select("#"+data.datum.StoryNumber)
	// 		.attr("r", rScale(data.datum.Uniqueness))
	// 		.attr("stroke-width", "0")
	// }

	// const splitTwoWords = (str, group='HRT') => {
	// 	let regexp = /\S+ \S+/g
	// 	const matches = str.matchAll(regexp);
	// 	let coolArray = Array.from(str.matchAll(regexp), m => m[0]);
	
	// 	if (str.split(' ').length % 2 != 0) {
	// 		coolArray = [...coolArray, str.split(' ').slice(-1)]
	// 	}

	// 	if (coolArray.length > 1) {
	// 		return coolArray
	// 	} else {
	// 		return [group, str]
	// 	}
	// }

	// let legendData = [{x:0, Uniqueness:1}, {x:20, Uniqueness:5}, {x:50, Uniqueness:10}]

	// link to logo
	// let src = 'images/oasisLogo.svg';

	// change of view
	// $: view = "horizontal"
	// $: outerWidth = 0
	// $: innerWidth = 0
	// $: outerHeight = 0
	// $: innerHeight = 0
	// console.log("screenwidth", innerWidth)
	// if(innerWidth<600) {
	// 	view = "vertical"
	// 	bHeight = 1500
	// 	console.log(innerWidth)
	// } else {
	// 	view = "horizontal"
	// 	bHeight = 300
	// }

	// if(view==="vertical") {
	// 	bHeight = 1500
	// } else {
	// 	bHeight = 300
	// }

    // flyto location in globe mode
    // $: if (country==="World") {
        

    // }

    function flyToCity(map, selection) {
		
		// const selectionData = data.filter(d=>d.ID_HDC_G0===selection)
		// console.log("selectionData", selectionData)
		const coords = [selection.lng, selection.lat]
		
		// NEW METHOD
		map.flyTo({
						center: coords,
						essential: true,
						zoom:1.7,
						// maxZoom: 12,
						// minZoom: 9,
						// speed: 0.5, // make the flying slow
						// curve: 1, // change the speed at which it zooms out
					})
    }

    function showTooltipGlobe(selection) {

        const coords = [selection.lng, selection.lat]
        const cityData = selection
		const cityfifteenMinProp = (cityData.fifteenPropAccess).toFixed()>100?100:(cityData.fifteenPropAccess).toFixed()
		const accessValue = cityData.accessibility
		const accessNormValue = distanceToNormGlobe(accessValue)
		const color = accessScale(accessNormValue)
		// console.log(accessNormValue)
		selectAll(".mapboxgl-popup").remove()

		new mapboxgl.Popup()
			.setLngLat(coords)
			.setHTML(`<span style="color: ${mainDrawColor}; text-align:left; font-weight:700">${cityData.UC_NM_CTR}</span><br>
				<span style="color: ${mainDrawColor}; text-align:left;">Average walking time to services:</span>
				<span style="color:${color};font-weight:700"> ${walkingTime(accessValue, true, false)}</span><br>
				<span style="color: ${mainDrawColor}; text-align:left;">% of pop. within 15 min of services:</span>
				<span style="color:${color};font-weight:700"> ${cityfifteenMinProp}%</span><br>`)
			.addTo(map);

            // <span style="color: ${mainDrawColor}; opacity:0.7">(👆 click me to explore)</span>
		
		selectAll(".mapboxgl-popup-content")
		// .style("background-color", multiValue==="dark"?"black":"rgb(248, 248, 248)")
		.style("background-color", darkMode===true?mainBgColorControls:"rgb(248, 248, 248)")
		// .style("fill", multiValue==="dark"?"#ccc":"black")
		.style("fill", darkMode===false?"#ccc":mainBgColorControls)
		.style("border", `${borderWidthTooltip}px solid ${mainBorderColor}`)
        .style("box-shadow", `${darkMode===true?"none":boxShadow}`)

        selectAll(".mapboxgl-popup-content")
		.append("button")
		.style("color",mainDrawColor)
		.style("background-color", mainBgColorControls)
		.style("margin-bottom", 0)
		.style("margin-top", "5px")
        .attr("class", "tooltipButton")
        .style("font-size", "10px")
        .style("text-transform", "uppercase")
        .style("cursor", "pointer")
        // .style("font-family", "'Josefin Sans', sans-serif;")
		// .style("border", `${borderWidthButtons}px solid ${mainBorderColor}`)
		.text("👆 click me to explore")
		.on("click", (d,e)=>{
			selectedCity.set(cityData.ID_HDC_G0)
			selectedCityName.set(cityData.UC_NM_CTR)
			selectedCountry.set(cityData.CTR_MN_NM)
			flyToNewCity(map, $selectedCity)
			selectAll(".mapboxgl-popup").remove()
		})
    }

    // $: console.log("tickplot Data", data)

</script>

<!-- <svelte:window bind:innerWidth bind:outerWidth bind:innerHeight bind:outerHeight /> -->
<!-- <p>
	Inner Width: {innerWidth}
</p> -->
<!-- <div bind:clientWidth={width}> -->
    <div>
    <!-- {#if showLegend===true}
        <svg {width} height={50}>
            <g transform={`translate(${(width)/2},0)`}>
                {#each legendData as data, i}
                    <circle
                    class="legendCircle"
                    stroke=#4d004b
                    cy={margin.top/2}
                    cx={data.x-25}
                    r={rScale(data.Uniqueness)}
                    >
                    </circle>
                    <text
                    class="legendTicks"
                    y={margin.top}
                    x={data.x-25}
                    text-anchor={i===0?"end":i===2?"start":""}
                    >
                    {i===0?"Less Unique":i===2?"More Unique":""}
                    </text>
                {/each}
                <br><br>
            </g>
        </svg>
    {/if} -->
	<svg {width} height={bHeight}>
			<!-- {#if view==="horizontal"} -->
            <!-- {#if country!=="World"} -->
            {#if country==="x"}
                <g transform={`translate(0,${margin.top})`}>
                    {#each data as d, i}
                        <!-- svelte-ignore a11y-mouse-events-have-key-events -->
                        <line
                        class="circleStory"
                        id={d.ID_HDC_G0}
                        y1='{20}' 
                        y2='{40}'
                        x1={xScale(+d[xVar])}
                        x2={xScale(+d[xVar])}
                        stroke={highlightCities.includes(d.UC_NM_CTR)?mainSpecialColor:mainDrawColor}
                        stroke-width={highlightCities.includes(d.UC_NM_CTR)||(cityHovered!==null&&d.UC_NM_CTR===cityHovered.UC_NM_CTR)?"4px":"0.7px"}
                        z-index={highlightCities.includes(d.UC_NM_CTR)?1000:0}
                        on:mouseover={()=>{
                            cityHovered=d
                            // fly to location on hover
                            if (country==="World") {
                                flyToCity(map, d)
                                showTooltipGlobe(d)
                            }
                        }}
                        on:mouseleave={()=>cityHovered=null}
                        />
                        <!-- <circle
                        class="circleStory"
                        id={d.ID_HDC_G0}
                        
                        cy='{40}'
                        cx={xScale(+d[xVar])}
                        r="3"
                        stroke={highlightCities.includes(d.UC_NM_CTR)?mainSpecialColor:mainDrawColor}
                        stroke-width={highlightCities.includes(d.UC_NM_CTR)||(cityHovered!==null&&d.UC_NM_CTR===cityHovered.UC_NM_CTR)?"4px":"0.7px"}
                        z-index={highlightCities.includes(d.UC_NM_CTR)?1000:0}
                        on:mouseover={()=>{
                            cityHovered=d
                            
                            if (country==="World") {
                                flyToCity(map, d)
                                showTooltipGlobe(d)
                            }
                        }}
                        on:mouseleave={()=>cityHovered=null}
                        /> -->
                        {#if highlightCities.includes(d.UC_NM_CTR)&&cityHovered===null}
                            <!-- <line 
                            style="z-index:1"
                            stroke={mainSpecialColor} 
                            y1={margin.top} 
                            y2={(height-margin.bottom)-(i*(radius*2))} 
                            x1={x(bin.x0)} 
                            x2={x(bin.x0)}
                            /> -->
                            <!-- <text class="tick" fill={mainDrawColor} y={margin.top} dx={5} x={x(bin.x0)}>
                                {aggData.filter(c=>c[variable.value]===city)[0].UC_NM_CTR}
                            </text> -->
                            <text 
                            class="annotation" 
                            fill={mainSpecialColor} 
                            y={15} 
                            x={xScale(+d[xVar])}
                            text-anchor={d[xVar]>=50?"end":"start"} 
                            >
                                {width>900?d.UC_NM_CTR:d.UC_NM_MN}
                            </text>
                        {/if}
                        {#if cityHovered!==null&& !highlightCities.includes(cityHovered.UC_NM_CTR)}
                            <text 
                            class="annotation" 
                            fill={mainDrawColor} 
                            y={15} 
                            x={xScale(cityHovered[xVar])}
                            text-anchor={cityHovered[xVar]>=50?"end":"start"} 
                            >
                                {width>900?cityHovered.UC_NM_CTR:cityHovered.UC_NM_MN}
                            </text>
                        {/if}
                    {/each}
                    <use xlink:href="#{selectedCityId}"/>
                </g>
                <!-- {:else if country==="World"} -->
                {:else}
                    <g transform={`translate(0,${bHeight/2})`}>
                        {#each positionedData as data, i}
                        <!-- svelte-ignore a11y-mouse-events-have-key-events -->
                        <!-- strokewidth highlightCities.includes(data.datum.UC_NM_CTR)|| -->
                        <!-- darkMode===true?mainDrawColor:mainBgColorControls -->
                        <!-- in:scale={{ delay: 50, duration: 2000, easing: quintOut }}
                        out:fade={{ delay: 0, duration: 0, easing: quintOut }} -->
                        <circle
                        class="circleStory"
                        id={data.datum.ID_HDC_G0}
                        cy={data.y}
                        cx={data.x}
                        r={rScale(data.datum.P15)}
                        style="fill:{darkMode===true?
                                highlightCities.includes(data.datum.UC_NM_CTR)?mainSpecialColor:mainSvgColor:
                                mainSpecialColor};
                        stroke:{(cityHovered!==null&&data.datum.UC_NM_CTR===cityHovered.UC_NM_CTR)||highlightCities.includes(data.datum.UC_NM_CTR)?mainSpecialColor:darkMode===true?mainDrawColor:mainSpecialColor};
                        stroke-width:{(cityHovered!==null&&data.datum.UC_NM_CTR===cityHovered.UC_NM_CTR)?"2px":"0.7px"};
                        fill-opacity:{darkMode===false?
                                    highlightCities.includes(data.datum.UC_NM_CTR)?1:0.2:1};
                        stroke-opacity:1"
                        z-index={highlightCities.includes(data.datum.UC_NM_CTR)?1000:0}
                        on:mouseover={()=>{
                            cityHovered=data.datum
                            cityhoveredY = data.y
                            // fly to location on hover
                            if (country==="World") {
                                flyToCity(map, data.datum)
                                showTooltipGlobe(data.datum)
                            }
                        }}
                        on:mouseleave={()=>cityHovered=null}
                        />
                        {#if highlightCities.includes(data.datum.UC_NM_CTR)&&cityHovered===null}
                            <!-- <line 
                            style="z-index:1"
                            stroke={mainSpecialColor} 
                            y1={margin.top} 
                            y2={(height-margin.bottom)-(i*(radius*2))} 
                            x1={x(bin.x0)} 
                            x2={x(bin.x0)}
                            /> -->
                            <!-- <text class="tick" fill={mainDrawColor} y={margin.top} dx={5} x={x(bin.x0)}>
                                {aggData.filter(c=>c[variable.value]===city)[0].UC_NM_CTR}
                            </text> -->
                            <text 
                            class="annotation" 
                            fill={mainSpecialColor} 
                            y={-bHeight/2+18} 
                            x={xScale(+data.datum[xVar])}
                            text-anchor={data.datum[xVar]>=50?"end":"start"} 
                            >{#if width>900&&(data.datum.CTR_MN_NM.split(" ").length>1)}
                                {data.datum.UC_NM_MN+", "}
                                    {#each data.datum.CTR_MN_NM.split(" ") as t, i}
                                        {t[0]+"."}
                                    {/each}
                                {:else if width>900&&(data.datum.CTR_MN_NM.split(" ").length===1)}
                                    {data.datum.UC_NM_MN+", "+data.datum.CTR_MN_NM}
                                {:else}
                                    {data.datum.UC_NM_MN}
                                {/if}
                            </text>
                            <line 
                            stroke={mainSpecialColor} 
                            opacity=0.7
                            y1={-bHeight/2+20} 
                            y2='{data.y-2}'
                            x1={data.x} 
                            x2={data.x}
                            stroke-dasharray="2"
                            stroke-width="0.5px"
                            />
                            <!-- {width>900&&(data.datum.CTR_MN_NM.split(" ").length>1)?
                                    data.datum.UC_NM_MN+", "+data.datum.CTR_MN_NM.split(" ")[0][0]+"."+data.datum.CTR_MN_NM.split(" ")[1][0]+".":
                                width>900&&(data.datum.CTR_MN_NM.split(" ").length===1)?
                                    data.datum.UC_NM_CTR:
                                    data.datum.UC_NM_CTR} -->
                        {/if}
                        {#if cityHovered!==null&& !highlightCities.includes(cityHovered.UC_NM_CTR)}
                            <text 
                            class="annotation" 
                            font-weight="300px"
                            fill={mainDrawColor} 
                            y={-bHeight/2+18} 
                            x={xScale(cityHovered[xVar])}
                            text-anchor={cityHovered[xVar]>=50?"end":"start"} 
                            >
                                {width>900?cityHovered.UC_NM_CTR:cityHovered.UC_NM_MN}
                            </text>
                            <line 
                            stroke={mainDrawColor} 
                            opacity=0.7
                            y1={-bHeight/2+18} 
                            y2='{cityhoveredY-2}'
                            x1={xScale(cityHovered[xVar])} 
                            x2={xScale(cityHovered[xVar])}
                            stroke-dasharray="2"
                            stroke-width="0.5px"
                            />
                        {/if}
                        {/each}
                    </g>
                {/if}
				<!-- <AxisBS scale={xScale} view={view}/> -->
			<g class='axis x-axis'>
				{#each xTicks as tick, i}
				<g transform='translate({xScale(tick)},0)'>
					<!-- <line stroke={mainDrawColor} y1='{0}' y2='{bHeight-margin.bottom/1.5}'/> -->
                    <line stroke={mainDrawColor} y1='{bHeight - 27}' y2='{bHeight - 23}'/>
					<text class='tick' fill={mainDrawColor} y='{bHeight - 14}'>{tick+"%"}</text>
                    <!-- {#if i===xTicks.length-1 && axisLabel===true}
                    <text fill={mainDrawColor} class='tickLabel' dx={-100} y='{bHeight}'>proportion of population within 15 min of services</text>
                    {/if} -->
                    {#if i===0 && axisLabel===true}
                        <text fill={mainDrawColor} class='tickLabel' dx={0} y='{bHeight-5}'>% of population within 15 min of services</text>
                    {:else if i===0 && axisLabel===false}
                        <text fill={mainDrawColor} class='tickLabel' dx={0} y='{bHeight-5}'>% of pop. within 15 min of services</text>
                    {/if}
				</g>
				{/each}
			</g>
            <!-- annotation for selected city -->
            <g>
                <line 
                stroke={mainDrawColor} 
                y1='{0}' 
                y2='{bHeight-margin.bottom}'
                x1={xScale(countryAvg)} 
                x2={xScale(countryAvg)}
                stroke-dasharray="2"
                stroke-width="0.5px"
                />
                <text 
                class="tick" 
                fill={mainDrawColor} 
                y={margin.top-3} 
                text-anchor={countryAvg>=50?"end":"start"} 
                dx={countryAvg>=50?-5:5}
                x={xScale(countryAvg)}>
                    {country} average: {countryAvg===undefined?"":countryAvg.toFixed()}%
                </text>
            </g>
    </svg>
</div>

<style>

    /* .tooltipButton {
		font-family: 'Josefin Sans', sans-serif;
	} */
    

	.tick line {
    opacity:0.3;
	stroke-dasharray: 2;
    z-index: -100
	}

    .tick {
        font-size: 10px; 
    }


  .tick text {
		/* font-size: 10px; */
    /* font-size:11px; */
    font-size: 10px;
	text-transform: uppercase;
	font-weight: 500
	}

    .tickLabel {
        text-transform:lowercase;
        /* text-anchor:end; */
        text-anchor:start;
        font-size: 10px; 
        font-weight: 500;
    }

    .annotation {
		/* font-size: 10px; */
    /* font-size:11px; */
    font-size: 10px;
	/* text-transform: uppercase; */
	font-weight: 500
	}

	.x-axis {
		text-anchor: middle;
	}
	

	.circleStory {
		cursor: pointer;
		/* stroke-width: 2px; */
		/* fill: rgb(252, 252, 224) */
	}

</style>

<!-- alternate, rects -->
<!-- y={data.x}
                x={data.y}
                width={rScale(data.datum.Uniqueness)*2}
                height={rScale(data.datum.Uniqueness)*2}
                rx=50
                ry=50 -->